
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
// import ReactPaginate from 'react-paginate'
import Select from 'react-select';
import Moment from 'moment';
import { Form, FormGroup } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import HrStore from '../../../stores/HrStore'
import PrintButtons from 'component/element/PrintButtons'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import IframeModal from 'component/element/IframeModal'
import { momentHelper } from './helpers'
const localStorageKey = 'kkc.reportSummaryOT'
class ReportSummaryOT extends Component {

  constructor(...args) {
    super(...args)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const curMonth = parseInt(Moment().format('MM'))
    // const curDay = parseInt(Moment().format('DD'))
    const all_day = Moment().daysInMonth()

    const optionsDay = []
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }

    for (var i=0;i<=all_day;i++) {
      if (i == 0) {
        var label = "ทั้งเดือน"
      } else {
        var label = i
      }
      optionsDay.push({
        value: i,
        label: label
      })
    }
    
    const optionsMonth = [
      { value: 0, label: 'ทั้งปี' },
      { value: 1, label: 'มกราคม' },
      { value: 2, label: 'กุมภาพันธ์' },
      { value: 3, label: 'มีนาคม' },
      { value: 4, label: 'เมษายน' },
      { value: 5, label: 'พฤษภาคม' },
      { value: 6, label: 'มิถุนายน' },
      { value: 7, label: 'กรกฎาคม' },
      { value: 8, label: 'สิงหาคม' },
      { value: 9, label: 'กันยายน' },
      { value: 10, label: 'ตุลาคม' },
      { value: 11, label: 'พฤศจิกายน' },
      { value: 12, label: 'ธันวาคม' }
    ];

    this.state = {
      loading: false, 
      data: [],
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth,
      defaultYear: yTh,
      defaultMonth: curMonth,
      sort: JSON.parse(localStorage.getItem(localStorageKey)) || {sortStatus:'',sortStatus2:''}
    }
    this.refTableId = 'ReportSummaryOT-'+Math.ceil(Math.random()*100);
  }

  onYearChange(e) {
    let {defaultYear,defaultMonth} = this.state
    defaultYear = e.value
    this.setState({defaultYear:defaultYear})
    this.loadData(e.value-543,defaultMonth)
  }

  onMonthChange(e) {
    let {defaultYear,defaultMonth} = this.state
    defaultMonth = e.value
    this.setState({defaultMonth:defaultMonth})
    this.loadData(defaultYear-543,e.value)
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  getNumberFormat(value) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let total = 0
    data.forEach((item,index)=> {
      let value = item[field].replace(' บาท','')
      total += (value===''||value===null||value===undefined||isNaN(value)?0:value*1)
    }) 
    return total
  }

  loadData(year = '', month = '') {
  	if (year==='')
  		year = this.state.defaultYear-543

  	if (month==='')
  		month = this.state.defaultMonth

    let that = this
    let {sort} = this.state
    this.setState({loading:true})
    HrStore.loadReportOT(year,month,function(result) {
      let data = result.data
      if (sort.sortStatus===''&&sort.sortStatus2==='') {  
        data = result.data
      } else {
        if (sort.sortStatus!=='') {
          if (sort.sortStatus===''||sort.sortStatus==='desc') {
            data.sort(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
            data.reverse(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
          } else if (sort.sortStatus==='asc') {
            data.sort(function(a, b) {
              if(a.employee_id < b.employee_id) return -1;
              if(a.employee_id > b.employee_id) return 1;
              return 0;
            })
          }
        } else if (sort.sortStatus2!=='') {
          if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
            data.reverse(function(a, b) {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            })
          } else if (sort.sortStatus2==='asc') {
            data.sort(function(a, b) {
              if(a.name < b.name) return -1;
              if(a.name > b.name) return 1;
              return 0;
            })
          }
        }
      }
      that.setState({loading:false,data:data})
    })
  }

  onPrintTable() {
    let url = ''
    let param = 'PrintReportSummaryOT&year='+this.state.defaultYear+'&month='+this.state.defaultMonth
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcel() {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงาน OT รวม.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  renderToolbar() {
    return (
      	<Form inline>
            <FormGroup style={{marginBottom:'5px'}}>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultYear }
                options={this.state.optionsYear}
                style={{ width: "80px" }}
                onChange={ this.onYearChange.bind(this) }
              />
            </FormGroup>  
            {' '}
            <FormGroup style={{marginBottom:'5px'}}>
              <Select
                clearable={false}
                name="form-field-name"
                value={ this.state.defaultMonth }
                options={this.state.optionsMonth}
                style={{ width: "110px" }}
                onChange={ this.onMonthChange.bind(this) }
              />
            </FormGroup>
            {' '}
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px'}}>
              <PrintButtons
                  onPrintTable={this.onPrintTable.bind(this)}
                  onExportExcel={this.onExportExcel.bind(this)}
                  marginLeft='0'
                  width='auto'
              />
            </FormGroup>
        </Form>    
    )
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
    	return(<tr><td colSpan={6}>ไม่พบข้อมูล</td></tr>)
    } else {
    	return(
    		data.map((item,index) => {
    			return(
    				<tr key={index}>
    					<td>{item.employee_id}</td>
    					<td>{item.name}</td>
    					<td>{item.nick_name}</td>
    					<td>{item.position}</td>
    					<td>{item.department}</td>
    					<td className='text-right'>{item.ot_text}</td>
    				</tr>
    			)
    		})
    	)
    }
  }

  getDate() {
    let {defaultYear,defaultMonth} = this.state
    let month = defaultMonth
    let year = defaultYear
    let text = 'ประจำเดือน '
    text += momentHelper.getMonthText(month)+' '+year
    if (year==='0'||year==='00'||year===0) {
      text = 'ทั้งหมด'
    } else if (month==='0'||month==='00'||month===0) {
      text = 'ประจำปี '+year
    }
    return text 
  }

  renderTable() {
    let {sort} = this.state
    return (
        <div className='table-responsive'>
          <table id={this.refTableId} className='table table-hover table-bordered-solid'>
            <thead>
              <tr>
                <th style={{display:'none'}} colSpan={6}>{'รายงาน OT รวม '+this.getDate()}</th>
              </tr>
              <tr>
              	<th onClick={this.onSortClick.bind(this,'code')}>รหัสพนักงาน&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus===''?'sort':sort.sortStatus==='asc'?'sort-asc':sort.sortStatus==='desc'?'sort-desc':'sort')} /></th>
                <th onClick={this.onSortClick.bind(this,'name')}>ชื่อ-นามสกุล&nbsp;<FontAwesome className={'pull-right'} name={(sort.sortStatus2===''?'sort':sort.sortStatus2==='asc'?'sort-asc':sort.sortStatus2==='desc'?'sort-desc':'sort')} /></th>
                <th>ชื่อเล่น</th>
                <th>ตำแหน่ง</th>
                <th>แผนก</th>
                <th>จำนวนเงิน (บาท)</th>
              </tr>
            </thead>
            <tbody>
              {this.renderRowData()}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={5} className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-right'>{this.getNumberFormat(this.getSummary('ot_text'))}</th>
              </tr>
            </tfoot>
          </table>
        </div>
    )
  }

  onSortClick(key,e) {
    let {data,sort} = this.state
    if (data!==undefined&&data.length>1) {
      if (key==='code') {
        if (sort.sortStatus===''||sort.sortStatus==='desc') {
          sort.sortStatus = 'asc'
          data.sort(function(a, b) {
            if(a.employee_id < b.employee_id) return -1;
            if(a.employee_id > b.employee_id) return 1;
            return 0;
          })
        } else if (sort.sortStatus==='asc') {
          sort.sortStatus = 'desc'
          data.reverse(function(a, b) {
            if(a.employee_id < b.employee_id) return -1;
            if(a.employee_id > b.employee_id) return 1;
            return 0;
          })
        }
        sort.sortStatus2 = ''
      } else if (key==='name') { 
        if (sort.sortStatus2===''||sort.sortStatus2==='desc') {
          sort.sortStatus2 = 'asc'
          data.sort(function(a, b) {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
          })
        } else if (sort.sortStatus2==='asc') {
          sort.sortStatus2 = 'desc'
          data.reverse(function(a, b) {
            if(a.name < b.name) return -1;
            if(a.name > b.name) return 1;
            return 0;
          })
        }
        sort.sortStatus = ''
      }
      let reportEmConfig = {sortStatus:sort.sortStatus,sortStatus2:sort.sortStatus2}
      localStorage.setItem(localStorageKey, JSON.stringify(reportEmConfig))
      this.setState({data:data,sort:sort})
    }  
  }

  render() {
    let title = 'ตาราง OT ทั้งปี'
    let {report} = this.props
    return (
      <div>
        <Box loading={this.state.loading}>
          <Box.Header border={true}>
          {
            report=='ReportCategoryPage'
            ?this.props.renderMenu()
            :<Box.Title>{title}</Box.Title>
          }
          </Box.Header>
          <Box.Body>
            {this.renderToolbar()}
            {this.renderTable()}
          </Box.Body>
        </Box>
        <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
      </div>  
    )
  }
}


ReportSummaryOT.defaultProps = {
  show: false,
  report: ''
}
export default ReportSummaryOT;



// WEBPACK FOOTER //
// ./src/view/hr/report/ReportSummaryOT.js